/**
 * Accordion
 */

export default function TSCT_Accordion() {
	const selectors = {
		src: ".accordion-src",
		dist: ".accordion-dist",
		accordions: ".accordions",
		accordion: ".single-accordion",
		icon: ".faq-icon",
	};

	this.init = () => {
		jQuery(document).ready(function ($) {
			if ($(selectors.accordion).length) {
				$(selectors.accordion).each(function () {
					const el = $(this);
					el.find(selectors.dist).slideUp(400);
					el.find(selectors.icon).removeClass("fa-minus");
					el.find(selectors.icon).addClass("fa-plus");
				});
			}
			$(selectors.src).on("click", function (e) {
				$(this).closest(selectors.accordions).find(selectors.dist).slideUp(400);
				$(this)
					.closest(selectors.accordions)
					.find(selectors.icon)
					.removeClass("fa-minus");
				$(this)
					.closest(selectors.accordions)
					.find(selectors.icon)
					.addClass("fa-plus");
				$(this)
					.closest(selectors.accordion)
					.find(selectors.dist)
					.slideDown(400);
				$(this)
					.closest(selectors.accordion)
					.find(selectors.icon)
					.removeClass("fa-plus");
				$(this)
					.closest(selectors.accordion)
					.find(selectors.icon)
					.addClass("fa-minus");
			});
		});
	};
}
